// [@vidstack/eliza] THIS FILE IS AUTO GENERATED - SEE `eliza.config.ts`

import "../../define/vds-play-button.js";
import * as React from "react";
import { createComponent } from "../lib/index.js";
import { PlayButtonElement } from "../../ui/play-button/index.js";

const EVENTS = {} as const;

/** A button for toggling the playback state (play/pause) of the current media.

💡 The following media attributes are applied:

- `media-paused`: Applied when media playback has paused. */
const PlayButton = createComponent(
  React,
  "vds-play-button",
  PlayButtonElement,
  EVENTS,
  "PlayButton"
);

export default PlayButton;
